import axios from 'axios';
import './App.css';
import ThemeRoutes from './routes';
axios.defaults.withCredentials = true;
const App = () => (
  <ThemeRoutes />
)

export default App;
